import "../../styles/superAdmin/addModule.css";
import { EllipsisOutlined } from "@ant-design/icons";
import { Skeleton } from "antd";
import { Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  closeModal,
  openModal,
  openDrawer,
  closeDrawer,
} from "../../redux/Admin/adminActions";
import ModuleEditModal from "../UI/superAdmin/module_edit_modal";
import { useGetActiveModules } from "../../hooks/useGetActiveModules";
import { useGetInActiveModules } from "../../hooks/useGetInactiveModules";
import SkeletonUI from "../UI/superAdmin/loaders/SkeletonUI";
import ErrorPopup from "../UI/superAdmin/modals/ErrorModal";
import SuccessPopup from "../UI/superAdmin/modals/SuccessModal";
import axios from "axios";
import { useState } from "react";

export default function AddModule() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state) => state.admin.modalOpen);
  const isDrawerOpen = useSelector((state) => state.admin.drawerOpen);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleModalOpen = (id) => dispatch(openModal(id));
  const handleModalClose = (id) => dispatch(closeModal(id));
  const handleDrawerOpen = (id) => dispatch(openDrawer(id));
  const handleDrawerClose = (id) => dispatch(closeDrawer(id));

  const {
    data: activeModules,
    isLoading: activeModulesLoading,
    refetch: activeModulesRefetch,
  } = useGetActiveModules();
  const {
    data: inActiveModules,
    isLoading: inActiveModulesLoading,
    refetch: inactiveModulesRefetch,
  } = useGetInActiveModules();

  const handleUpdateStatus = async (status, id) => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("superAdminToken");

      if (!token) {
        return console.error("Token not found");
      }

      const payload = {};

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/super-admin/update-module-status/${id}?status=${status}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage(response.data.message);
      console.log({ response });
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      handleModalOpen(null);
      activeModulesRefetch();
      inactiveModulesRefetch();
    } catch (error) {
      setIsLoading(false);

      const apiErrors = error?.response?.data?.errors;
      const fallbackMessage =
        error?.response?.data?.message || "Something went wrong";

      if (apiErrors && typeof apiErrors === "object") {
        // Always extract the first message
        const firstErrorMessage =
          Object.values(apiErrors)[0]?.[0] || fallbackMessage;
        setErrorMessage(firstErrorMessage);
      } else {
        setErrorMessage(fallbackMessage);
      }

      console.error("Error:", error.response?.data || error.message);
    }
  };


  const renderSkeletonCard = () => (
    <div className="col-12 col-sm-6 col-md-6 col-lg-3">
      <div className="super-admin-card p-3 rounded-3">
        <Skeleton avatar paragraph={{ rows: 2 }} active />
      </div>
    </div>
  );
  const renderModuleCard = (item, isActive = false) => (
    <div key={item.id} className="col-12 col-sm-6 col-md-6 col-lg-3">
      <div className="super-admin-card d-flex justify-content-between p-3 rounded-3">
        <div className="d-flex align-items-center">
          <div className="me-3">
            <img src={item.image} alt="card" className="card-image" />
          </div>
          <div>
            <p className="mb-1">{item.name}</p>
          </div>
        </div>
        <div
          className="super-admin-card-icon"
          onClick={() => {
            handleModalOpen(item.id);
          }}
        >
          <EllipsisOutlined />
        </div>

        <Modal
          className="custom-modal"
          width={200}
          open={isModalOpen[item.id]}
          closable={false}
          onCancel={() => handleModalClose(item.id)}
          footer={null}
        >
          <div className="d-flex flex-column gap-3">
            <button
              className="modal_button"
              onClick={() => {
                isActive
                  ? handleUpdateStatus("inactive", item?.id)
                  : handleUpdateStatus("active", item?.id);
              }}
            >
              {isLoading
                ? isActive
                  ? "Deactivating..."
                  : "Activating..."
                : isActive
                ? "Deactivate"
                : "Activate"}
            </button>
            <button
              className="modal_button"
              onClick={() => handleDrawerOpen(item.id)}
            >
              Edit
            </button>
          </div>
        </Modal>

        <ModuleEditModal
          open={isDrawerOpen[item.id]}
          onClose={handleDrawerClose}
          values={item}
          index={item.id}
        />
      </div>
    </div>
  );

  return (
    <>
      {successMessage && (
        <SuccessPopup
          message={successMessage}
          onClose={() => setSuccessMessage(null)}
        />
      )}
      {errorMessage && (
        <ErrorPopup
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      )}

      <section className="container-fluid">
        <div className="module-header-container mb-4" id="negative-margin">
          <h1>Add Module</h1>
          <p className="text-muted">
            Modules can be activated or deactivated here
          </p>
        </div>

        <div className="super-admin-cards-container rounded-3 p-4">
          {/* Inactive Modules */}
          <div className="module-container mb-4">
            <h2 className="box-header h5 font-weight-bold">Inactive Modules</h2>
          </div>
          <div className="row g-3 mb-4">
            {inActiveModulesLoading ? (
              <SkeletonUI />
            ) : inActiveModules?.payload?.length ? (
              inActiveModules.payload.map((item) =>
                renderModuleCard(item, false)
              )
            ) : (
              <div className="text-muted text-center w-100 py-4">
                No inactive modules
              </div>
            )}
          </div>

          {/* Active Modules */}
          <div className="module-container mb-4">
            <h2 className="box-header h5 font-weight-bold">Active Modules</h2>
          </div>
          <div className="row g-3">
            {activeModulesLoading ? (
              <SkeletonUI />
            ) : activeModules?.payload?.length ? (
              activeModules.payload.map((item) => renderModuleCard(item, true))
            ) : (
              <div className="text-muted text-center w-100 py-4">
                No active modules
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
